/** Old cached rules have only a key; keep their page titles readable and stable. */
export function ruleTitleFromKey(key: string): string {
  const readable = key.replace(/^[a-z]{2,3}-/u, '').replaceAll(/[-_]/gu, ' ').replaceAll(':', ': ')
  return readable.charAt(0).toUpperCase() + readable.slice(1)
}
